export enum Command {
	AssetList = 'AssetList',
	ViewContext = 'ViewContext',
	SetViewContext = 'SetViewContext',
	BoundaryVisibility = 'BoundaryVisibility',
	OnHover = 'OnHover',
	CompassHeading = 'CompassHeading',
	GWSavedData = 'GWSavedData',
	SetInteractionMode = 'SetInteractionMode',
	Outlinemap = 'Outlinemap',
	Heatmap = 'Heatmap',
	ToolSelect = 'ToolSelect',
	connect = 'connect',
	SetEnvironment = 'SetEnvironment',
	CameraRangeAlert = 'CameraRangeAlert',
	UserInput = 'UserInput',
	SetViewContextError = 'SetViewContextError',
	AssetSelected = 'AssetSelected',
	UtilsScreenShot = 'UtilsScreenShot',
}
